import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { BarristerService } from 'src/app/service/pages/barrister.service';

@Component({
  selector: 'app-holiday-modal',
  templateUrl: './holiday-modal.component.html',
  styleUrls: ['./holiday-modal.component.css']
})
export class HolidayModalComponent implements OnInit {

  private _subs: Subscription = new Subscription();
  holiday : {
    'id' : string, 
    'barristerId' : string,
    'unavailableFrom' : string, 
    'unavailableTo' : string,
    'reason' : string
  };

  constructor(
    private msgService : MessageService,
    private barristerService : BarristerService,
    @Inject(MAT_DIALOG_DATA) public data : any,
    private dialogRef : MatDialogRef<HolidayModalComponent>,
  ) {
    this.holiday = {
      'id' : '', 
      'barristerId' : '',
      'unavailableFrom' : '', 
      'unavailableTo' : '',
      'reason' : ''
    } 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    if(this.data.id){
      this.barristerService.getHolidays(this.data.id, 'all').subscribe(res=>{
        this.holiday = res.data[0];
      })
    }
  }

  saveHolidayData(holiDayData){
    if(this.data.id){
      this.updateHoliday(this.data.id, holiDayData);
    }else{
      this.saveHoliday(holiDayData);
    }
  }

  updateHoliday(id, holiDayData){
    this._subs.add(
      this.barristerService.updateHoliday(id, holiDayData).subscribe(res=>{
        if(res.status == 'ok'){
          this.dialogRef.close(res);
          this.msgService.success(res.message);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  saveHoliday(holiDayData){
    holiDayData.barristerId = this.data.barristerId;
    this._subs.add(
      this.barristerService.saveHoliday(holiDayData).subscribe(res=>{
        if(res.status == 'ok'){
          this.dialogRef.close(res);
          this.msgService.success(res.message);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
